import { useCallback, useState } from 'react'

const useInputValue = (initialValue: string) => {
  const [value, setValue] = useState(initialValue)
  const onChange = useCallback((event: Record<string, any> | null) => {
    setValue(event?.currentTarget?.value ?? '')
  }, [])

  return {
    value,
    onChange,
  }
}

export default useInputValue
